import { ActivatedRoute, RouterLink } from '@angular/router';
import { Component, OnInit, inject } from '@angular/core';

import { AddressRenderInfoComponent } from '../../address-render-info/address-render-info.component';
import { ChipDetailsResponse } from '@app/shared/models/chip-details.model';
import { ChipService } from '@app/pages/chip-registration/services/chip.service';
import { DatePipe } from '@angular/common';
import { SIZE_LIST } from '@app/pages/clinic/models/static.data';
import { TranslatePipe } from '@ngx-translate/core';
import { getBreedByTypeAndId } from '@shared/helpers/breed.helper';
import { isCode15 } from '@app/models/chip-code.type';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-chip-detail-view',
    imports: [DatePipe, AddressRenderInfoComponent, RouterLink, TranslatePipe],
    providers: [ChipService],
    templateUrl: './chip-detail-view.component.html',
    styleUrl: './chip-detail-view.component.scss',
})
export class ChipDetailViewComponent implements OnInit {
    private chipService = inject(ChipService);
    private route = inject(ActivatedRoute);
    chipDetails!: ChipDetailsResponse;

    ngOnInit(): void {
        const routeCode = this.route.snapshot.paramMap.get('code');
        if (routeCode && isCode15(routeCode)) {
            this.chipService
                .getChipDetailInfo(routeCode)
                .subscribe((res) => (this.chipDetails = res));
        }
    }

    getAnimalBreed(): string {
        return getBreedByTypeAndId(this.chipDetails?.animal.type, this.chipDetails?.animal.breed);
    }

    getAnimalSize(): string {
        return SIZE_LIST.find((size) => size.id === +this.chipDetails.animal.size)?.name || '';
    }
}
